import { NavigationCarousel } from '@/features/carousel';
import BirthdayProductCard from './birthday-product-card';
import BirthdayProductsListSkeleton from './skeleton';
import birthdayProductsData from '../birthday-products.json';
const BirthdayProductsList = () => {
  return <div className='homepage-container relative my-2 min-h-[225] lg:min-h-[339px]' data-sentry-component="BirthdayProductsList" data-sentry-source-file="index.tsx">
            <NavigationCarousel options={{
      perView: 'auto',
      mode: 'free-snap',
      spacing: 8,
      breakPoints: {
        mobile: {
          perView: 2.3
        },
        desktop: {
          perView: 5.8
        }
      }
    }} skeleton={<BirthdayProductsListSkeleton />} staticChildren data-sentry-element="NavigationCarousel" data-sentry-source-file="index.tsx">
                {birthdayProductsData.map((item, index) => {
        return <div key={index} data-index={index} className='keen-slider__slide min-w-fit max-w-fit px-0'>
                            <BirthdayProductCard name={item.name} basePrice={item.basePrice} salesPrice={item.salesPrice} discountPercent={item.discountPercent} image={item.image} brand={item.brand} />
                        </div>;
      })}
            </NavigationCarousel>
        </div>;
};
export default BirthdayProductsList;